import axios from "axios";

export const getEquiposMedicion = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/equipos-medicion`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const descargarExcelEquiposMedicion = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/equipos-medicion/generar-excel`,
      {},
      {
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const eliminarEquipoMedicion = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/equipo-medicion/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRegistroTelefonico = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/registro-telefonico`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrganigramaCFE = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/organigrama`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const buscarContactosCFE = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/buscarContactosCFE`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTiposCargos = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tiposCargos`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generarExcelContactosCFE = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/contactosCFE/generar-excel`,
      data,
      {
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const crearContactoCFE = async (API_URL, data) => {
  try {
    const response = await axios.post(`${API_URL}/api/contactosCFE`, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const actualizarContactoCFE = async (API_URL, data) => {
  try {
    const response = await axios.put(`${API_URL}/api/contactosCFE`, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const eliminarContactoCFE = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/contactosCFE/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTiposTensionEquipo = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-tension-equipo`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVoltajesEquiposMedicionPorTipoTension = async (
  API_URL,
  tipo
) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/voltajes-equipos-medicion-por-tipo-tension?tipo=${tipo}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTiposEquipo = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-equipo`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createEquipoMedicion = async (API_URL, data) => {
  try {
    const response = await axios.post(`${API_URL}/api/equipo-medicion`, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEquipoMedicion = async (API_URL, data) => {
  try {
    const response = await axios.put(`${API_URL}/api/equipo-medicion`, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const calcularEquipoMedicion = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/seleccionar-equipos-medicion`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const descargarPDFEquiposMedicion = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/equipos-medicion/generar-pdf`,
      data,
      {
        responseType: "blob",
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTiposNumeroTelefonico = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-numero-telefonico`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createRegistroTelefonico = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/registro-telefonico`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateRegistroTelefonico = async (API_URL, data) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/registro-telefonico`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteRegistroTelefonico = async (API_URL, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/registro-telefonico/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verificarManuales = async (API_URL, tipoManual) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/verificar-manuales?tipoManual=${tipoManual}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const descargarManual = async (API_URL, tipoManual) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/descargar-manual?tipoManual=${tipoManual}&date=${Date.now()}`,
      {
        responseType: "blob",
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cambiarUrlEncuesta = async (API_URL, urlEncuesta) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/cambiar-url-encuesta?urlEncuesta=${urlEncuesta}`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subirArchivoManual = async (API_URL, file, tipoManual) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${API_URL}/api/subir-manuales?tipoManual=${tipoManual}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
